export default __webpack_public_path__ + "static/media/right_arrow.b90693d0.svg";